import { FC, useEffect, useState } from "react"
import classNames from "classnames"
import styles from "./../../../../../components/buttons/button.module.scss"
import React from "react"
import { SearchOption } from "../../../../../@types/enumsGlobal"
import { IEntitySimpleDTO } from "../../../../../libs/coreapi-dto/@types/common"
import useGridFilter, { CreateSelectorGridFilter } from "../../../../../system/hooks/useGridFilter"
import { ProgressActionSpinner } from "../../../../../components/progressActionSpinner/ProgressActionSpinner"

interface IButtonProps {
    children: React.ReactNode
    variant: "primary" | "outprimary" | "secondary" | "outsecondary" | "danger" | "commandPanel" | "gray" | "kizPanel"
    disabled?: boolean
    className?: string
    isLoadingSpinner?: boolean
    isLoadingGlobal?: boolean
    style?: React.CSSProperties
    onClick?: () => any
    buttonType?: 'button' | 'submit' | 'reset'
}

const Button = React.forwardRef<HTMLButtonElement, IButtonProps>((props, ref) => {
    function getType(v: IButtonProps["variant"]) {
        switch (v) {
            case "primary": return styles.btnPrimary
            case "outprimary": return styles.btnOutPrimary
            case "secondary": return styles.btnSecondary
            case "outsecondary": return styles.btnOutSecondary
            case "danger": return styles.btnDanger
            case "commandPanel": return styles.commandPanel
            case "gray": return styles.btnGray
            case "kizPanel": return styles.btnKizPanel
        }
    }

    return (
        <>
            <button
                type={props.buttonType}
                ref={ref}
                disabled={props.disabled}
                className={classNames(getType(props.variant), props.className)}
                style={props.style}
                onClick={props.onClick}
                onKeyDown={(e) => {
                    if (e.key === 'Escape') {
                        e.currentTarget.blur()
                    }
                }}
            >
                {props.isLoadingSpinner ? <i className={styles.spinner}></i> : null}
                {props.children}
            </button>
            {props.isLoadingGlobal ? <ProgressActionSpinner transparency /> : null}
        </>
    )
})

const GridSelectorButton: FC<IGridSelectorInputProps> = (props) => {


    const [visible, setVisible] = useState<boolean>(false)
    const [searchQuery, setSearchQuery] = useState<string>(props.value ?? "")
    const [gridFilter, dispatchGridFilter] = useGridFilter(props.gridFilter ?? CreateSelectorGridFilter)
    const [isEnterPressed, setIsEnterPressed] = useState<boolean>(false)

    useEffect(() => {
        if (props.gridFilter) {
            dispatchGridFilter({
                ...gridFilter,
                type: "newGridFilters",
                payload: props.gridFilter,
            })
        }
    }, [props.gridFilter])

    useEffect(() => {
        if (visible) props.setScanData?.(undefined)
    }, [visible])

    useEffect(() => {
        if (props?.selectedEntity) {
            setSearchQuery(props.numereticInput ? props?.selectedEntity : props.selectedEntity.displayName)
        } else {
            setSearchQuery("")
        }
    }, [props?.selectedEntity])

    useEffect(() => {
        if (props?.searchOption) {
            setSearchQuery("")
            Object.values(SearchOption).forEach((option) => {
                if (props.dispatchGridFilter) {
                    props.dispatchGridFilter?.({
                        type: "deleteColumnFilter",
                        payload: option,
                    })
                } else {
                    dispatchGridFilter({
                        type: "deleteColumnFilter",
                        payload: option,
                    })
                }
            })
        }
    }, [props?.searchOption])

    useEffect(() => {
        if (props?.excludeContractor)
            dispatchGridFilter?.({
                type: "addColumnFilter",
                payload: {
                    name: "IdGlobal",
                    value: props?.excludeContractor,
                    operator: "NotEq",
                } as IGridColumnFilter,
            })
    }, [props?.excludeContractor])

    const addColumnParamFilter = (payloadValue: string): void => {
        if (payloadValue != null && payloadValue.trim().length != 0) {
            if (props.dispatchGridFilter) {
                props.dispatchGridFilter?.({
                    type: "paramFilter",
                    payload: {
                        gridParamFilter: {
                            ...(gridFilter.paramFilter || {}),
                            goodsName: payloadValue,
                            idGosContractGlobal: props.gosContract,
                            idStoreGlobal: props.idStoreSupplier
                        },
                        sortDesc: "Perc",
                    },
                })
            } else {
                dispatchGridFilter?.({
                    type: "paramFilter",
                    payload: {
                        gridParamFilter: {
                            ...(gridFilter.paramFilter || {}),
                            goodsName: payloadValue,
                            idGosContractGlobal: props.gosContract,
                            idStoreGlobal: props.idStoreSupplier
                        },
                        sortDesc: "Perc",
                    },
                })
            }
        }
        if (payloadValue.trim().length == 0 && props.idStoreSupplier) {
            if (props.dispatchGridFilter) {
                props.dispatchGridFilter?.({
                    type: "paramFilter",
                    payload: {
                        gridParamFilter: {
                            ...(gridFilter.paramFilter || {}),
                            idStoreGlobal: props.idStoreSupplier
                        },
                        sortDesc: "Perc",
                    },
                })
            } else {
                dispatchGridFilter?.({
                    type: "paramFilter",
                    payload: {
                        gridParamFilter: {
                            ...(gridFilter.paramFilter || {}),
                            idStoreGlobal: props.idStoreSupplier
                        },
                        sortDesc: "Perc",
                    },
                })
            }
        }
    }

    const addColumnSimpleFilter = (payloadValue: string, nameColumn: string): void => {
        if (payloadValue) {
            dispatchGridFilter?.({
                type: "addColumnFilter",
                payload: {
                    name: nameColumn,
                    operator: "Like",
                    value: payloadValue + "%",
                } as IGridColumnFilter,
            })
        }
    }

    const addColumnSimpleFilterNumber = (payloadValue: number, nameColumn: string): void => {
        if (payloadValue) {
            dispatchGridFilter?.({
                type: "addColumnFilter",
                payload: {
                    name: nameColumn,
                    operator: "Like",
                    value: payloadValue,
                } as IGridColumnFilter,
            })
        }
    }

    const addColumnAndParamFilter = (payloadValue: string, nameColumn: string): void => {
        const baseParamFilter = props.idStoreSupplier ? { idStoreGlobal: props.idStoreSupplier } : {}
        if (payloadValue != null && payloadValue.trim().length != 0) {
            if (props.dispatchGridFilter) {
                props.dispatchGridFilter?.({
                    type: "paramSimpleFilter",
                    payload: {
                        gridParamFilter: baseParamFilter,
                        gridColumnFilter: [
                            {
                                name: nameColumn,
                                operator: "Like",
                                value: payloadValue + "%",
                            },
                            {
                                name: "deleted",
                                operator: "Eq",
                                value: false,
                            },
                        ]
                    }
                })
            } else {
                dispatchGridFilter?.({
                    type: "paramSimpleFilter",
                    payload: {
                        gridParamFilter: baseParamFilter,
                        gridColumnFilter: [
                            {
                                name: nameColumn,
                                operator: "Like",
                                value: payloadValue + "%",
                            },
                            {
                                name: "deleted",
                                operator: "Eq",
                                value: false,
                            },
                        ]
                    }
                })
            }
        }
        if (payloadValue.trim().length == 0 && props.idStoreSupplier) {
            if (props.dispatchGridFilter) {
                props.dispatchGridFilter?.({
                    type: "paramSimpleFilter",
                    payload: {
                        gridParamFilter: baseParamFilter,
                        gridColumnFilter: [
                            {
                                name: "deleted",
                                operator: "Eq",
                                value: false,
                            },
                        ]
                    }
                })
            } else {
                dispatchGridFilter?.({
                    type: "paramSimpleFilter",
                    payload: {
                        gridParamFilter: baseParamFilter,
                        gridColumnFilter: [
                            {
                                name: "deleted",
                                operator: "Eq",
                                value: false,
                            },
                        ]
                    }
                })
            }
        }
    }

    const deleteColumnFilter = (): void => {
        if (props.dispatchGridFilter) {
            props.dispatchGridFilter?.({
                type: "paramSimpleFilter",
                payload: {
                    gridColumnFilter: props.gridFilter?.columnFilters,
                    gridParamFilter: props.idStoreSupplier ? { idStoreGlobal: props.idStoreSupplier } : {},
                },
            })
        } else {
            dispatchGridFilter?.({
                type: "paramSimpleFilter",
                payload: {
                    gridColumnFilter: props.gridFilter?.columnFilters ?? CreateSelectorGridFilter.columnFilters,
                    gridParamFilter: props.idStoreSupplier ? { idStoreGlobal: props.idStoreSupplier } : {},
                },
            })
        }
    }

    const handleButtonClick = (): void => {
        props.onFocus?.()
        setVisible(true)

        if (props.searchOption === SearchOption.name || props.searchOption === SearchOption.goodsName) {
            if (searchQuery && props.valid && props.valid()) {
                addColumnParamFilter(searchQuery)
            }
        } else if (props.searchOption === SearchOption.tradeName && searchQuery) {
            addColumnAndParamFilter(searchQuery, 'tradeName')
        } else if (props.searchOption === SearchOption.substanceName && searchQuery) {
            addColumnAndParamFilter(searchQuery, 'substanceName')
        } else if (props.searchOption === SearchOption.cureFormName && searchQuery) {
            addColumnSimpleFilter(searchQuery, 'cureFormName')
        } else if (props.searchOption === "n_fv" && searchQuery) {
            const numericValue = parseFloat(searchQuery)
            if (!isNaN(numericValue)) {
                addColumnSimpleFilterNumber(numericValue, 'n_fv')
            }
        } else if (props.searchOption === SearchOption.dosage && searchQuery) {
            addColumnSimpleFilter(searchQuery, 'dosage')
        } else if (props.searchOption === SearchOption.goodsCodeBylot && searchQuery) {
            addColumnSimpleFilter(searchQuery, SearchOption.goodsCode)
        }
    }

    const handleClear = (): void => {
        deleteColumnFilter()
        props.onChange?.("")
        setSearchQuery("")
        props.onClear?.()
    }

    const getButtonText = (): string => {
        if (props.selectedEntity) {
            return props.numereticInput ? props.selectedEntity : props.selectedEntity.displayName
        }
        return props.placeholder ?? "-- Не выбрано --"
    }

    return (
        <>
            <div className={props.className}>
                {props.label && (
                    <label className={classNames(styles.label, props.labelClassName)}>
                        {props.label}
                        {props.required && <span className={styles.required}>*</span>}
                    </label>
                )}
                <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                    <Button
                        variant={props.variant || "outprimary"}
                        disabled={props.disabled}
                        onClick={handleButtonClick}
                        className={classNames({
                            [styles.error]: props.error,
                        })}
                    >
                        {getButtonText()}
                    </Button>

                    {!props.hiddenClearButton && props.selectedEntity && (
                        <Button
                            variant="outsecondary"
                            onClick={handleClear}
                            disabled={props.disabled}
                        >
                            Очистить
                        </Button>
                    )}
                </div>

                {props.error && (
                    <div className={styles.errorMessage}>{props.error}</div>
                )}
            </div>

            {visible && (
                <props.selectorModalJsx
                    idGlobal={props.idGlobal}
                    idTable={props?.idTable}
                    isEnabledTo={props.isEnabledTo}
                    masterIdGlobal={props.masterIdGlobal}
                    gosContract={props.gosContract}
                    idStoreSupplier={props.idStoreSupplier}
                    onlyGridDisplayName={props.onlyGridDisplayName}
                    getUniqueGoodsByStore={props.getUniqueGoodsByStore}
                    onlyLotRemain={props.onlyLotRemain}
                    gridFilter={gridFilter}
                    dispatchGridFilter={props.dispatchGridFilter}
                    selectedEntity={props.selectedEntity}
                    searchQuery={searchQuery}
                    isCasheSave={props?.isCasheSave}
                    data={props?.data}
                    ok={(entity: IEntitySimpleDTO) => {
                        setVisible(false)
                        setSearchQuery("")
                        deleteColumnFilter()
                        props.onSelect?.(props.numereticInput ? parseFloat(entity.displayName) : entity, searchQuery)
                    }}
                    cancel={(verified: boolean) => {
                        verified && props.onClear?.()
                        deleteColumnFilter()
                        setVisible(false)
                    }}
                    setCasheData={(data) => props.setCasheData && props?.setCasheData(data)}
                    treeViewCheckDirectoryType={props.treeViewCheckDirectoryType}
                    isEnterPressed={isEnterPressed}
                    setIsEnterPressed={() => setIsEnterPressed(false)}
                    applyUserFilter={props.applyUserFilter}
                    excludeUserFilter={props.excludeUserFilter}
                    excludeContractors={props.excludeContractors}
                    activateGroupProcessing={props.activateGroupProcessing ?? false}
                />
            )}
        </>
    )
}

export default GridSelectorButton